import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import PageTitle from "../../components/common/PageTitle";
import GradientButton from "../../components/common/GradientButton";

const Panel = ({ children }) => (
  <div className="bg-white rounded-lg shadow-lg p-4 border-t-4 border-primary mb-4">
    <div>{children}</div>
  </div>
);

/*
User Name
Email
First Name
Last Name
drop down - Level of MSO
[] Send User Email Notification about their account
 */
const NewUsers = () => (
  <>
    <PageTitle title="Add a New User" />
    <div className="mt-4">
      <div className="flex-1 mr-4">
        <Panel>
          <Formik
            initialValues={{
              email: "",
              username: "",
              lastName: "",
              firstName: "",
              notify: false,
            }}
            validate={(values) => {
              const errors = {};
              if (!values.email) {
                errors.email = "Required";
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = "Invalid email address";
              }
              if (!values.username) {
                errors.username = "Required";
              }
              if (!values.lastName) {
                errors.lastName = "Required";
              }
              if (!values.firstName) {
                errors.firstName = "Required";
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                alert(JSON.stringify(values, null, 2));
                setSubmitting(false);
              }, 400);
            }}
          >
            {({ isSubmitting, values }) => (
              <Form>
                <label className="block font-bold mt-2" htmlFor="username">
                  User Name
                </label>
                <Field
                  className="px-2 py-1 outline-none border-1 border w-full block"
                  id="username"
                  type="text"
                  name="username"
                />
                <ErrorMessage
                  className="text-red-500 text-sm"
                  name="username"
                  component="div"
                />
                <label className="block font-bold mt-2" htmlFor="email">
                  Email
                </label>
                <Field
                  className="px-2 py-1 outline-none border-1 border w-full block"
                  id="email"
                  type="email"
                  name="email"
                />
                <ErrorMessage
                  className="text-red-500 text-sm"
                  name="email"
                  component="div"
                />
                <label className="block font-bold mt-2" htmlFor="firstName">
                  First Name
                </label>
                <Field
                  className="px-2 py-1 outline-none border-1 border w-full block"
                  id="firstName"
                  type="texxt"
                  name="firstName"
                />
                <ErrorMessage
                  className="text-red-500 text-sm"
                  name="firstName"
                  component="div"
                />
                <label className="block font-bold mt-2" htmlFor="lastName">
                  Last Name
                </label>
                <Field
                  className="px-2 py-1 outline-none border-1 border w-full block"
                  id="lastName"
                  type="text"
                  name="lastName"
                />
                <ErrorMessage
                  className="text-red-500 text-sm"
                  name="lastName"
                  component="div"
                />
                <label className="block font-bold mt-2" htmlFor="level">
                  Level Of MSO
                </label>
                <Field
                  className="px-2 py-1 outline-none border-1 border w-full block"
                  as="select"
                  name="level"
                  id="level"
                >
                  <option value={0}>0</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                </Field>
                <div className="flex flex-row items-center mt-2">
                  <Field id="notify" type="checkbox" name="notify" />
                  <label htmlFor="notify" className="ml-2 font-bold">
                    Send User Email Notification about their account
                  </label>
                </div>
                <GradientButton className="mt-4" disabled text="Add New User" />
              </Form>
            )}
          </Formik>
        </Panel>
      </div>
    </div>
  </>
);

export default NewUsers;
